import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Dropdown } from '@surglogs-app/icons'

import {
  getCSSObjectFromStyleProps,
  StyleProps,
} from '../styleProps/StylePropsService'

export const DropdownIcon = styled(Dropdown, {
  shouldForwardProp: (propName) =>
    !['isExpanded', 'isDisabled'].includes(propName),
})<{ isExpanded?: boolean; isDisabled?: boolean } & StyleProps>`
  width: ${({ theme }) => theme.ui.spacings['abs.12']};
  height: ${({ theme }) => theme.ui.spacings.lg};
  transition: transform 0.2s ease-out;
  cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
  flex-shrink: 0;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      transform: rotate(180deg);
    `};

  ${getCSSObjectFromStyleProps}
`
